// @flow

import * as React from 'react';
import { Link as RRLink } from 'react-router-dom';
import type { LocationShape } from 'react-router-dom';
import styled from 'styled-components';
import { UIContextPropType } from './UIProvider';
import type { UIProviderContext } from './UIProvider';
import { Text } from './Text';

type Props = {
  id: string,
  to: string | LocationShape,
  children?: React.Node,
  disabled?: boolean,
  className?: string,
  onClick?: (event: any) => void,
};

const TextComponent = styled(Text)`
  color: ${(props) =>
    props.disabled ? props.theme.disabledColor : props.theme.actionColor};
`;

const LinkFactory = () => {
  return class UnstyledLink extends React.Component<Props> {
    context: UIProviderContext;

    static contextTypes = {
      dbui: UIContextPropType,
    };

    renderTextComponent = () => {
      const { children, disabled, className } = this.props;

      return (
        <TextComponent className={className} disabled={disabled}>
          {children}
        </TextComponent>
      );
    };

    render() {
      const { disabled, ...props } = this.props;

      if (disabled) return this.renderTextComponent();

      return <RRLink {...props}>{this.renderTextComponent()}</RRLink>;
    }
  };
};

const StyledLink = styled(LinkFactory())`
  text-decoration: none;
`;

export const Link = (props: Props) => <StyledLink {...props} />;
